{
  "footer": {
    "text": {
      "imprint": "Imprint",
      "privacy-policy": "Privacy policy",
      "powered": "Powered by Lumxi GmbH"
    }
  }
}
